export enum IndicatorEmultiStatusEnum {
	Finished = 1,
	Pending = 2,
	Lost = 3,
}
